<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.461050625,0.9317646622657776C4.301050625,0.9317646622657776,0.931640625,4.301174662265778,0.931640625,8.461174662265778C0.931640625,12.621164662265777,4.301050625,15.990564662265777,8.461050625,15.990564662265777C12.621040625,15.990564662265777,15.990440625,12.621164662265777,15.990440625,8.461174662265778C15.990440625,4.301174662265778,12.621040625,0.9317646622657776,8.461050625,0.9317646622657776C8.461050625,0.9317646622657776,8.461050625,0.9317646622657776,8.461050625,0.9317646622657776ZM2.8139906249999997,8.461174662265778C2.8139906249999997,5.345884662265777,5.345760625,2.8141146622657773,8.461050625,2.8141146622657773C9.684580625,2.8141146622657773,10.804580625,3.2094146622657775,11.726940625,3.8682346622657775C11.726940625,3.8682346622657775,3.868110625,11.727064662265777,3.868110625,11.727064662265777C3.209290625,10.804704662265777,2.8139906249999997,9.684704662265778,2.8139906249999997,8.461174662265778C2.8139906249999997,8.461174662265778,2.8139906249999997,8.461174662265778,2.8139906249999997,8.461174662265778ZM8.461050625,14.108264662265778C7.237520625,14.108264662265778,6.117520625,13.712964662265778,5.195170625,13.054164662265778C5.195170625,13.054164662265778,13.054040625,5.195294662265778,13.054040625,5.195294662265778C13.712840625,6.117644662265778,14.108140625,7.237644662265778,14.108140625,8.461174662265778C14.108140625,11.585864662265777,11.585740625,14.108264662265778,8.461050625,14.108264662265778C8.461050625,14.108264662265778,8.461050625,14.108264662265778,8.461050625,14.108264662265778Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Disable',
} as DefineComponent
</script>
